import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
} from "@/components/ui/library/card";
import { useCourseForm } from "@/features/universityAndCourse/contexts/FormCourseContext";
import IntakeSelector from "./IntakeSelector";

export default function CourseFeesIntakes() {
  const { register, errors } = useCourseForm();

  return (
    <Card className="bg-white border-[#e6e8e7] w-full gap-4 p-4">
      <CardHeader className="px-0 py-0 gap-0">
        <CardTitle className="font-medium text-base text-black tracking-[-0.32px]">
          Fees & Intakes
        </CardTitle>
      </CardHeader>

      <CardContent className="px-0 py-0">
        <div className="flex flex-col gap-3 pl-2 w-full">
          {/* Tuition Fee */}
          <div className="flex flex-col gap-1.5 w-full">
            <Label
              htmlFor="tuition-fee"
              className="text-[#051912] text-sm tracking-[-0.56px] font-normal leading-[1.35]"
            >
              Tuition fee{" "}
              <span className="text-[#505e59]">(per year, optional)</span>
            </Label>
            <Input
              id="tuition-fee"
              type="number"
              min={0}
              placeholder="Eg. 18500"
              {...register("minFee")}
              className={`bg-[#fcfcfc] border-[#cdd1d0] h-10 rounded-xl px-3 py-2 text-sm text-[#505e59] tracking-[-0.56px] ${
                errors.minFee ? "border-red-500 focus-visible:ring-red-500" : ""
              }`}
            />
            {errors.minFee?.message && (
              <p className="text-xs text-red-500 tracking-[-0.24px]">
                {String(errors.minFee.message)}
              </p>
            )}
          </div>

          {/* Intakes */}
          <IntakeSelector />
        </div>
      </CardContent>
    </Card>
  );
}
